import React, { useState, useEffect } from "react";
import style from "../../style/HistoryListBody.module.scss";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import PenToSquareRegular from "../Icon/PenToSquareRegular";
import dayjs from "dayjs";
// import CaseCheckRegular from "../Icon/CaseCheckRegular";
// import PatientCheckRegular from "../Icon/PatientCheckRegular";
// import CaseXmarkRegular from "../Icon/CaseXmarkRegular";
// import PatientXmarkRegular from "../Icon/PatientXmarkRegular";
// import BellSlashRegular from "../Icon/BellSlashRegular";
// import RectangleListRegular from "../Icon/RectangleListRegular";

function HistoryListBody({ data }) {
  const [isOtherHospital, setIsOtherHospital] = useState(null);
   //臨時帳號
   const [isTemp, setIsTemp] = useState(false);
  useEffect(() => {
    setIsOtherHospital(
      JSON.parse(localStorage.getItem("auth"))?.IsOtherHospital
    );
  }, [isOtherHospital]);

  useEffect(() => {   
    setIsTemp(JSON.parse(localStorage.getItem("auth"))?.IsTempAccount);
  }, []);
  //console.log(data);
  if (data?.ListDatas === null) {
    return <h1>沒有資料</h1>;
  }
  return (
    <Table className={style.table}>
      <Thead>
        <Tr className={style.table_title}>
          <Th className={style.table_title_self}>收案編號</Th>
          <Th className={style.table_title_self}>轉出醫院</Th>
          <Th className={style.table_title_self}>建檔時間</Th>
          <Th className={style.table_title_self}>姓名/年齡/性別</Th>
          <Th className={style.table_title_self}>Onset &rarr; NIHSS</Th>
          <Th className={style.table_title_self}>病人動向</Th>
          <Th className={style.table_title_self}>收案狀態</Th>
          <Th className={style.table_title_self}>病歷編輯</Th>
          <Th className={style.table_title_self}>最新操作者</Th>
        </Tr>
      </Thead>
      <Tbody>
        {data?.ListDatas?.map((v, i) => {
          return (
            <Tr key={i} className={style.table_body}>
              <Td className={style.table_body_self}>{v.CaseCode}</Td>
              <Td className={style.table_body_self}>{v.OriginalOrg}</Td>
              <Td className={style.table_body_self}>
                {dayjs(v.CreateDateTime).format("YYYY/MM/DD HH:mm")}
              </Td>
              <Td className={style.table_body_self}>
                <span style={{ paddingRight: "4px" }}>{v.Name}</span>
                {v.Age}
                {v.Sex === 1 ? "M" : ""}
                {v.Sex === 2 ? "F" : ""}
              </Td>
              <Td className={style.table_body_self}>
                {v.OnsetTime} &rarr; {v.Nihss}
              </Td>
              <Td className={style.table_body_self}>
                <p style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      width: "12px",
                      height: "12px",
                      background: `${v.PatientStatus.HexColor}`,
                      borderRadius: "50%",
                      margin: "5px",
                    }}
                  ></span>
                  {v.PatientStatus.Name}
                  {/* {isOtherHospital && v.PatientStatus.Code === 1 ? (
                    <XmarkRegular />
                  ) : (
                    ""
                  )}
                  {!isOtherHospital && v.PatientStatus.Code === 4 ? (
                    <>
                      <CheckRegular /> <XmarkRegular />
                    </>
                  ) : (
                    ""
                  )} */}
                </p>
              </Td>
              <Td className={style.table_body_self}>
                <p style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      width: "12px",
                      height: "12px",
                      background: `${v.CaseStatus.HexColor}`,
                      borderRadius: "50%",
                      margin: "5px",
                    }}
                  ></span>
                  {v.CaseStatus.Name}
                  {/* {isOtherHospital && v.CaseStatus.Code === 2 ? (
                    <BellSlashRegular />
                  ) : (
                    ""
                  )}
                  {(isOtherHospital && v.CaseStatus.Code === 4) ||
                  (isOtherHospital && v.CaseStatus.Code === 7) ? (
                    <>
                      <CheckRegular /> <XmarkRegular />
                    </>
                  ) : (
                    ""
                  )}
                  {isOtherHospital && v.CaseStatus.Code === 5 ? (
                    <XmarkRegular />
                  ) : (
                    ""
                  )}
                  {isOtherHospital && v.CaseStatus.Code === 8 ? (
                    <RectangleListRegular />
                  ) : (
                    ""
                  )} */}
                </p>
              </Td>
              <Td className={style.table_body_self}>
                {
                  <PenToSquareRegular
                    navigatePath={`/ReferralEditData?rowId=${v.RowId}`}
                    disabled={isTemp}
                  />
                }
              </Td>
              <Td className={style.table_body_self}>
                {v.UpdateUser}
                {dayjs(v.UpdateDateTime).format("MM/DD HH:mm")}
              </Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
}

export default HistoryListBody;
